/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class CheckMarkFilter {
    public static filter(): any {
        return (input: any): any => {
            return (input) ? '✓'  : '✘';
        };
    }
}


angular.module('beneple.global')
    .filter('checkmark', CheckMarkFilter.filter);



// WEBPACK FOOTER //
// ./frontend/scripts/global/filters/checkmark.filter.ts